import React from "react";

export const CheckIcon = ({ yellow }) => <svg style={{ marginRight: 0 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke={yellow ? "var(--orange6)" : "var(--green6)"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.5 10.0026L9.16667 11.6693L12.5 8.33594" stroke={yellow ? "var(--orange6)" : "var(--green6)"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

export const CollapseArrow = () => <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.5L6 6.5L11 1.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;
